import React, { useEffect, useState, useRef } from "react";

const formatNumber = (num, decimals = 2, decimalsSmall) => {
    if (num >= 1e9) return (num / 1e9).toFixed(decimals) + "B";
    if (num >= 1e6) return (num / 1e6).toFixed(decimals) + "M";
    if (num >= 1e3) return (num / 1e3).toFixed(decimals) + "k";
    return Number(num).toFixed(decimalsSmall ? decimals : 0).toLocaleString();
};

const CountUp = ({
    value = 0,
    duration = 1500,
    prefix = "",
    suffix = "",
    formatShort = false,
    decimals = false,
    decimalsSmall = false,
}) => {
    const [count, setCount] = useState(0);
    const rafRef = useRef(null);
    const startTimeRef = useRef(null);
    const startValueRef = useRef(0);
    const countRef = useRef(count);

    useEffect(() => {
        countRef.current = count;
    }, [count]);

    useEffect(() => {
        cancelAnimationFrame(rafRef.current);
        startTimeRef.current = null;
        startValueRef.current = countRef.current;

        const start = startValueRef.current;
        const end = value;

        const animate = (timestamp) => {
            if (!startTimeRef.current) startTimeRef.current = timestamp;
            const progress = timestamp - startTimeRef.current;
            const progressRatio = Math.min(progress / duration, 1);

            const easedProgress = progressRatio < 0.5
                ? 2 * progressRatio * progressRatio
                : -1 + (4 - 2 * progressRatio) * progressRatio;

            const current = start + (end - start) * easedProgress;

            setCount(decimals ? current : Math.floor(current));

            if (progress < duration) {
                rafRef.current = requestAnimationFrame(animate);
            } else {
                setCount(end);
            }
        };

        rafRef.current = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(rafRef.current);
    }, [value, duration, decimals]);

    const displayValue = formatShort
        ? formatNumber(count, decimals ? 2 : 0, decimalsSmall)
        : decimals
            ? Number(count).toFixed(2)
            : Math.floor(count).toLocaleString();

    return (
        <span>
            {prefix}
            {displayValue}
            {suffix}
        </span>
    );
};

export default CountUp;